import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/icons/icon-stacking-looks-button.svg'
import _imports_1 from '@/assets/icons/icon-stacking-looks-arrow.svg'


const _hoisted_1 = { class: "stacking-topbar-content" }
const _hoisted_2 = { class: "stacking-product-line ABChanelCorpo-2022-Regular lh-18 font-16" }
const _hoisted_3 = { class: "stacking-select-options" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "option-item-button" }

import useSelect from '@/hooks/use-select'
import {
  FormattedStacking,
  StackingSelectVisibility,
  useCameraFrameStore,
  useConfAndQueryStore,
  useLayoutStore,
  useStackingStore
} from '@/store'
import { storeToRefs } from 'pinia'
import { computed, watch } from 'vue'
import { ClickAction } from '@/data/report'
import {
  isHonor,
  isHuawei,
  isHuaweiNote,
  isIOS,
  isSMF721
} from '@/utils/device'

// eslint-disable-next-line no-undef

export default /*@__PURE__*/_defineComponent({
  __name: 'StackingSelect',
  props: {
  visibility: {
    type: String as () => StackingSelectVisibility,
    default: 'idle'
  }
},
  emits: ['show-all'],
  setup(__props, { emit: __emit }) {

const emit = __emit
// eslint-disable-next-line no-undef


const { report } = useConfAndQueryStore()
const stackingStore = useStackingStore()
const { selectedStackingSet, selectedStacking } = storeToRefs(stackingStore)
const { selectableStackings, selectStacking } = useSelect()
const cameraFrameStore = useCameraFrameStore()
const layoutStore = useLayoutStore()

const computedOpacity = computed(() => {
  const o = (layoutStore.drawerState.progress || 0) * 3
  return o < 0 ? 1 : o > 1 ? 0 : 1 - o
})
const computedOffsetY = computed(() => {
  return `${(layoutStore.drawerState.y || 0) / 4}px`
})

const showAllStackings = () => {
  report(ClickAction.COUNTER)
  emit('show-all')
}

const onBarClick = (stacking: FormattedStacking) => {
  report(ClickAction.STACKING_BAR, stacking.titleString)
  selectStacking(stacking)
}

const reset = () => {
  // console.log('[[ Selection ] Selected Stackings ]', selectableStackings.value)
  if (selectableStackings.value.length > 0) {
    setTimeout(() => {
      selectStacking(selectableStackings.value[0])
    }, 200)
  }
  setTimeout(() => {
    document.querySelector('.product-selector-wrapper')?.scrollTo({
      left: 0,
      behavior: 'instant'
    })
  }, 0)
}

watch(selectableStackings, reset, { immediate: true })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["stacking-topbar", [
      _unref(layoutStore).isDrawerExpaned20Percent ? 'all-panel-shown' : __props.visibility
    ]])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(selectedStackingSet)?.title[0]), 1),
        _createElementVNode("div", {
          class: "select-by-cover PingFangSC-Regular lh-24 font-14",
          onClick: showAllStackings
        }, [
          _cache[0] || (_cache[0] = _createElementVNode("img", {
            class: "select-by-cover-left-icon",
            src: _imports_0
          }, null, -1)),
          _createElementVNode("span", {
            class: _normalizeClass(["select-by-cover-counter", {
            'is-ios': _unref(isIOS),
            'is-huawei': _unref(isHuawei),
            'is-honor': _unref(isHonor),
            'is-huawei-note': _unref(isHuaweiNote),
            'is-sm-f721': _unref(isSMF721)
          }])
          }, _toDisplayString(_unref(selectableStackings).length) + "个造型", 3),
          _cache[1] || (_cache[1] = _createElementVNode("img", {
            class: "select-by-cover-right-icon",
            src: _imports_1
          }, null, -1))
        ])
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["stacking-select-toolbar", [
      __props.visibility,
      _unref(layoutStore).drawerStateClassName,
      _unref(layoutStore).isShownByClosingSnapLayer ? 'closing-snap-layer' : undefined
    ]]),
      style: _normalizeStyle({
      '--computed-opacity': computedOpacity.value,
      '--computed-offset-y': computedOffsetY.value
    })
    }, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectableStackings), (stacking) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "stacking-select-option",
            key: stacking.guid,
            onClick: ($event: any) => (onBarClick(stacking))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "option-item-background" }, null, -1)),
              (_unref(selectedStacking)?.guid === stacking.guid)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass({
              'option-item-foreground': true,
              loading: _unref(cameraFrameStore).isSkuLoading
            })
                  }, null, 2))
                : _createCommentVNode("", true)
            ])
          ], 8, _hoisted_4))
        }), 128))
      ])
    ], 6)
  ], 64))
}
}

})